import { Modal, Button } from "antd";
import React from "react";
import { CanAccess } from "../../template/authorization/Authorization";

const ConfirmDialog = ({
  visible,
  handleCancel,
  handleSave,
  hasCancel,
  isDangerButton,
  actionButtonText,
  title,
  contentText,
  cancelText = "",
}) => {
  return (
    <Modal
      className="modal-confirm"
      title={title}
      visible={visible}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={[
        hasCancel && (
          <Button
            key="back"
            onClick={handleCancel}
            className="btn-modal btn-default"
          >
            {cancelText ? cancelText : "Kembali"}
          </Button>
        ),
        <Button
          key="submit"
          type="primary"
          danger={isDangerButton}
          onClick={handleSave}
          className={isDangerButton ? "btn-modal-danger" : "btn-modal"}
        >
          {actionButtonText}
        </Button>,
      ]}
    >
      <div>{contentText}</div>
    </Modal>
  );
};

export default ConfirmDialog;
